// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnimationManagerController from "./animation_manager_controller"
application.register("animation-manager", AnimationManagerController)

import AnimationTriggerController from "./animation_trigger_controller"
application.register("animation-trigger", AnimationTriggerController)

import AutoReloadController from "./auto_reload_controller"
application.register("auto-reload", AutoReloadController)

import AutoRemoveController from "./auto_remove_controller"
application.register("auto-remove", AutoRemoveController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import BridgeSwitcherController from "./bridge_switcher_controller"
application.register("bridge-switcher", BridgeSwitcherController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import DigitInputController from "./digit_input_controller"
application.register("digit-input", DigitInputController)

import EmotionTriggerController from "./emotion_trigger_controller"
application.register("emotion-trigger", EmotionTriggerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HeroAvatarController from "./hero_avatar_controller"
application.register("hero-avatar", HeroAvatarController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LiteYoutubeController from "./lite_youtube_controller"
application.register("lite-youtube", LiteYoutubeController)

import LlmKeyPickerController from "./llm_key_picker_controller"
application.register("llm-key-picker", LlmKeyPickerController)

import LlmProviderPickerController from "./llm_provider_picker_controller"
application.register("llm-provider-picker", LlmProviderPickerController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MarketingImageController from "./marketing_image_controller"
application.register("marketing-image", MarketingImageController)

import ModelSlideoutController from "./model_slideout_controller"
application.register("model-slideout", ModelSlideoutController)

import ParleyController from "./parley_controller"
application.register("parley", ParleyController)

import PersonaPreviewController from "./persona_preview_controller"
application.register("persona-preview", PersonaPreviewController)

import PersonaSwitcherController from "./persona_switcher_controller"
application.register("persona-switcher", PersonaSwitcherController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SecretRevealController from "./secret_reveal_controller"
application.register("secret-reveal", SecretRevealController)

import SettingsController from "./settings_controller"
application.register("settings", SettingsController)

import SideNavController from "./side_nav_controller"
application.register("side-nav", SideNavController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import VariationPickerController from "./variation_picker_controller"
application.register("variation-picker", VariationPickerController)

import VoiceController from "./voice_controller"
application.register("voice", VoiceController)

import VoicePickerController from "./voice_picker_controller"
application.register("voice-picker", VoicePickerController)

import VoicePreviewController from "./voice_preview_controller"
application.register("voice-preview", VoicePreviewController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
